import { useRef, useState } from "react";
import { Upload, X, Image as ImageIcon } from "lucide-react";
import api, { resolveImage } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, label = "Görsel", testId = "image-upload" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) {
      toast.error("Dosya çok büyük (max 8MB)");
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Görsel yüklendi");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Yükleme başarısız");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const clear = () => onChange("");

  return (
    <div data-testid={testId}>
      <label className="block text-xs uppercase tracking-wider text-slate-500 mb-2">{label}</label>
      <div className="flex flex-col sm:flex-row gap-3 items-start">
        <div className="w-28 h-28 bg-slate-100 border border-slate-200 flex items-center justify-center overflow-hidden flex-shrink-0">
          {value ? (
            <img src={resolveImage(value)} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImageIcon size={28} className="text-slate-400" />
          )}
        </div>
        <div className="flex-1 space-y-2 w-full">
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => inputRef.current?.click()}
              disabled={uploading}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#0066FF] hover:bg-[#0A2540] disabled:opacity-60 text-white text-sm font-semibold transition-colors"
              data-testid={`${testId}-button`}
            >
              <Upload size={14} />
              {uploading ? "Yükleniyor..." : "Dosya Seç"}
            </button>
            {value && (
              <button
                type="button"
                onClick={clear}
                className="inline-flex items-center gap-2 px-3 py-2.5 border border-slate-300 hover:bg-slate-50 text-sm"
                data-testid={`${testId}-clear`}
              >
                <X size={14} /> Kaldır
              </button>
            )}
          </div>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={onFile}
            className="hidden"
            data-testid={`${testId}-input`}
          />
          <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="veya URL yapıştırın..."
            className="w-full px-3 py-2 border border-slate-200 focus:border-[#0066FF] outline-none text-xs"
            data-testid={`${testId}-url`}
          />
          <div className="text-[10px] text-slate-400 uppercase tracking-wider">
            JPG · PNG · WEBP · max 8MB
          </div>
        </div>
      </div>
    </div>
  );
}
